var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 240 240",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,1,-1,6.12323e-17,240,-2.93915e-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240,48C240,21.508 218.492,0 192,0L48,0C21.508,0 0,21.508 0,48L0,192C0,218.492 21.508,240 48,240L192,240C218.492,240 240,218.492 240,192L240,48Z",
    style: {
      fill: "rgb(51,51,51)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16667,0,0,1.16667,-20,-22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8,0,0,0.625,-42,38.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140,66L40,66L65,50L115,50L140,66Z",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "2.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,1,-80,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "2.26px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,1,50,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "rgb(146,199,72)",
      stroke: "rgb(146,199,72)",
      strokeWidth: "4.52px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,1,75,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "rgb(104,186,190)",
      stroke: "rgb(104,186,190)",
      strokeWidth: "4.52px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,1,100,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "rgb(239,201,79)",
      stroke: "rgb(239,201,79)",
      strokeWidth: "4.52px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,1,125,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "rgb(238,170,183)",
      stroke: "rgb(238,170,183)",
      strokeWidth: "4.52px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,1,60,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 90,
    width: 10,
    height: 60,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "2.26px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.5,0,80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 160,
    width: 180,
    height: 10,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.52px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon3);
export default __webpack_public_path__ + "static/media/favicon3.8ec1de76e44e06d67c3a0afcfc9bdd16.svg";
export { ForwardRef as ReactComponent };